import { useEffect, useState } from "react";
import { getToken, isSupported } from "firebase/messaging";
import { messaging } from "../lib/firebase";
import { supabase } from "../lib/supabaseClient";

type Props = {
  userId: string;
};

export default function PushPermissionSettings({ userId }: Props) {
  const [permission, setPermission] = useState<NotificationPermission>(
    Notification.permission
  );
  const [token, setToken] = useState<string | null>(null);
  const [status, setStatus] = useState<string>("");

  useEffect(() => {
    setPermission(Notification.permission);
  }, []);

  const requestPermission = async () => {
    if (!(await isSupported())) {
      setStatus("❌ Dein Browser unterstützt keine Push-Nachrichten");
      return;
    }

    try {
      const result = await Notification.requestPermission();
      setPermission(result);

      if (result === "granted") {
        const token = await getToken(messaging, {
          //vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
          vapidKey:
            "BLBMpj-QGt45qj8nG8OeJS9GDGKk4AThrROZ3FHDQ29HsQPkChOdIo8Hv4V5ouGHIV_FSG7CuOwCgiyFMQz7w6Y",
        });

        if (token) {
          setToken(token);

          const { error } = await supabase.from("user_push_tokens").upsert(
            {
              user_id: userId,
              token,
            },
            { onConflict: "user_id", ignoreDuplicates: false }
          );

          if (error) {
            setStatus("❌ Fehler beim Speichern des Tokens");
            console.error(error);
          } else {
            setStatus("✅ Push-Token gespeichert");
          }
        }
      } else if (result === "denied") {
        setStatus("⚠️ Push wurde abgelehnt");
      }
    } catch (e) {
      console.error("❌ Fehler bei der Anfrage:", e);
      setStatus("❌ Unerwarteter Fehler");
    }
  };

  return (
    <div className="mt-8 border border-[#2a3347] p-4 rounded-xl bg-[#161b27]">
      <h2 className="text-lg font-bold mb-2 text-slate-100">🔔 Push-Benachrichtigungen</h2>

      <p className="text-sm mb-4 text-slate-400">
        Du kannst Push-Benachrichtigungen aktivieren, um wichtige Hinweise wie
        neue Aufgaben oder Updates sofort zu erhalten.
      </p>

      <div className="mb-2">
        <span className="text-slate-200 font-medium">Status:</span>{" "}
        <span className="text-sm font-mono text-slate-300">{permission}</span>
      </div>

      {status && <div className="text-sm mt-1 text-sky-400">{status}</div>}

      {permission === "default" && (
        <button
          onClick={requestPermission}
          className="mt-3 bg-sky-500 text-white px-4 py-2 rounded hover:bg-sky-600"
        >
          ✅ Push aktivieren
        </button>
      )}

      {permission === "denied" && (
        <p className="text-sm text-red-400 mt-3">
          Du hast Push-Benachrichtigungen blockiert. Du kannst sie in den
          Browsereinstellungen erneut zulassen.
        </p>
      )}

      {permission === "granted" && token && (
        <p className="text-emerald-400 text-sm mt-3">
          ✅ Token gespeichert: {token.slice(0, 20)}…
        </p>
      )}
    </div>
  );
}
